import { c as _c } from "react/compiler-runtime";
import { memo } from 'react';
import type { IconPropsWithVariant } from './Icon';
import { IconWithVariants } from './Icon';
import type { IconVariantMap } from './icons-system';
import SystemIcons from './icons-system-sprite.svg';
type Props<IconName extends keyof IconVariantMap> = Omit<IconPropsWithVariant<IconVariantMap, IconName>, 'spriteSrc'>;
function IconSystemComponent(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <IconWithVariants spriteSrc={SystemIcons.src} role="img" {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export const IconSystem = memo(IconSystemComponent) as typeof IconSystemComponent;